var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.55 34.55"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.275 17.275a8.637 8.637 0 1 0-8.637-8.637 8.635 8.635 0 0 0 8.637 8.637m0 4.319C11.509 21.594 0 24.487 0 30.231v4.319h34.55v-4.319c0-5.744-11.51-8.637-17.275-8.637"
  })));
};
export default SvgProfile;